import React from "react";
import styled from "styled-components";
import { useToast } from "../context/ToastContext";
import Toast from "./Toast";

const Container = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const ToastContainer = () => {
  const { toasts, remove } = useToast();

  return (
    <Container>
      {toasts.map((t) => (
        <Toast key={t.id} message={t.message} type={t.type} onClose={() => remove(t.id)} />
      ))}
    </Container>
  );
};

export default ToastContainer;
